export default "__VITE_ASSET__CXgWVLjc__"